(ns dre.storage.events
  (:require
    [cljs.reader :as edn]
    [re-frame.core :as rf]))


(def ->key
  (partial keyword "docsearch"))

(defn set-ls
  [k v]
  (js/localStorage.setItem (->key k) (pr-str v)))

(defn load-ls
  [k]
  (->> (->key k)
       js/localStorage.getItem
       edn/read-string))

;; Co-effects

(rf/reg-cofx
  ::get
  (fn [cofx k]
    (->> (load-ls k)
         (assoc cofx k))))

;; Effects

(rf/reg-fx
  ::set
  (fn [[k v]]
    (set-ls k v)))
